// Func = limiting Scope for this file
var lastScrollTop = 0;

var homeGallery =  $(".home-gallery__container");
function homeGalleryF(){
	if( homeGallery ){
		if( window.innerWidth < 768 && ! homeGallery.hasClass('slick-initialized') ){
			homeGallery.slick({
				fade:true,
				arrows:false,
				dots:true
			});
		}else if( window.innerWidth > 768 && homeGallery.hasClass('slick-initialized') ){
			homeGallery.slick('unslick');
		}
	}
}

(function(){

	$(document).ready(function () {

		//Call function with browser is resized.
		$(window).resize(function (event) {
			//resizeWindow();
			homeGalleryF();
		}); 
		//resizeWindow();

		// Main Nav Dropdown
		$("#primary-nav li").hover(function(){
			$(this).addClass("hover");
			$('ul.submenu',this).fadeIn(200);
		}, function(){
			$(this).removeClass("hover");
			$('ul.submenu',this).fadeOut(200);
		});

		// Map: Return to previous page button. Change body id to match map template's name.
		//$('body#map-category-sidebar #content').prepend('<a class="btn return-from-map" href="javascript:history.back()">« Back to previous page</a>');
		
	});

	

	window.onload = function() {
		/*this function add a class to header when scroll down the page
		/* and change the logo by a new file if needed depending of mockup
		*/

		// scrollDownAction(20, 'scroll');

		scrollW();
		window.addEventListener('scroll', function(){
			scrollW();
		});

		//Rellax parallax
		if( document.querySelector('.rellax')){
			var rellax = new Rellax('.rellax');
		}

		homeGalleryF();

		var isie = document.querySelector('.is-ie');
		if(isie){
			document.querySelectorAll('.lazyload').forEach( (dis)=>{
				dis.setAttribute('src', dis.dataset.srcset);
				dis.classList.add('visible')
			});
			const image_fit = document.getElementsByClassName('ie-img');
			for(let i = 0; i < image_fit.length; i++ ){
				const this_image = image_fit[i].getElementsByTagName('img')[0];
				const image_src = this_image.getAttribute('src');
				image_fit[i].style.backgroundImage = 'url("'+image_src+'")';
			}
			
			const scrollanimations = document.getElementsByClassName('animate-fade');
			for(let i = 0; i < scrollanimations.length; i++ ){
				console.log(scrollanimations[i]);
				scrollanimations[i].setAttribute("class","animate-fade fade-in visible");
			}
		}
		
	};

	$('a.fancybox').fancybox();

}());

function scrollW(){
	//check scroll down or up for header styles
	let st = window.pageYOffset || document.documentElement.scrollTop;
	if(st > 80){
		if (st > lastScrollTop){
			// downscroll code
			if(!document.getElementById('header').classList.contains('down')){
				document.getElementById('header').classList.add('down');
				document.getElementById('header').classList.remove('up');
			}
		} else {
			// upscroll code
			if(!document.getElementById('header').classList.contains('up')){
				document.getElementById('header').classList.add('up');
				document.getElementById('header').classList.remove('down');
			}
		}
	} else {
		if(document.getElementById('header').classList.contains('up') || document.getElementById('header').classList.contains('down')){
			document.getElementById('header').classList.remove('up');
			document.getElementById('header').classList.remove('down');
		}
	}
	lastScrollTop = st <= 0 ? 0 : st; // For Mobile or negative scrolling
}

/* Menu Mobile */
var menubtn = document.querySelector('.hamburger__btn');
if(menubtn) {
	menubtn.addEventListener('click', function(){
		var menuObj = document.querySelector('.header__nav');
		if( menuObj.classList.contains('open') ){
			menuObj.classList.remove('open');
			menubtn.classList.remove('open');
		}else{
			menuObj.classList.add('open');
			menubtn.classList.add('open');
		}
		/* menuObj.classList.add('close');
		menuObj.classList.remove('open'); */
	});
}

function ScrollToSection(IdSection, margin){
	if (document.getElementById(IdSection)){
		let seccion = document.getElementById(IdSection);
		let posicion = seccion.getBoundingClientRect().top + window.scrollY - margin;
		window.scrollTo({ top: posicion, behavior: 'smooth' });
	}
	else{
		console.log("Id doesn't exist")
	}
}

function ConvertAnchorToId(anchor){
	let IdSection = anchor.substring(1).toLowerCase();
	if(IdSection == "stay-update"){
		IdSection = "third-nav",
		ScrollToSection(IdSection , 0);
	}
}

document.addEventListener('DOMContentLoaded', function () {
    let fragment = window.location.hash;
    if (fragment) {
		ConvertAnchorToId(fragment);
	}
});





